module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/martyna-stanczyk-ccc7997588977cf3892587056e0e416d.webp";